import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "特定商取引法に基づく表記", -1)
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      id: _ctx.$style.parent
    }, [
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("販売業者")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("和楽美")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_3,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("運営統括責任者名")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("横田川 侑暉")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_4,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("所在地")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("東京都板橋区板橋4-13-2-301")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_5,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("商品代金以外の必要料金の説明")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("全て電磁的提供による商品のみのためありません")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_6,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("申込有効期限")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("特にありません。")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_7,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("不良品")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("全て電磁的提供による商品のみのためありません")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_8,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("販売数量")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("制限なく購入いただけます。")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_9,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("お支払方法")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("クレジットカードがご利用になれます。")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_10,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("返品期限")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("プラン途中での解約は可能ですが返金は致しかねます。")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_11,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("返品送料")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("全て電磁的提供による商品のみのためありません")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_12,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("サービス名")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("和楽美.Online")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_13,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("電話番号")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("090-5116-8565")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_14,
      _createVNode(_component_el_row, {
        class: _normalizeClass(_ctx.$style.section)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("メールアドレス")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createTextVNode("warabinokai.2009@gmail.com")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ], 8, _hoisted_2)
  ], 64))
}